import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AbstractTCITenantComponent } from "./tci-tenant-component";
import { Component, Injectable } from "@angular/core";
import { implementsTKeys, ITCIValidationResult } from "@tci/common";

export interface ITCITenantRouteDeactivator {
    canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>;
}

@Injectable()
export class TciTenantRouteDeActivator implements CanDeactivate<any> {
    private static instance: TciTenantRouteDeActivator;

    private compMap: { [routeid: string]: ITCITenantRouteDeactivator } = {};

    public static getInstance(): TciTenantRouteDeActivator {
        if (!TciTenantRouteDeActivator.instance) {
            TciTenantRouteDeActivator.instance = new TciTenantRouteDeActivator();
        }
        return TciTenantRouteDeActivator.instance;
    }

    addRouteId(routeid: string, comp: ITCITenantRouteDeactivator) {
        this.compMap[routeid] = comp;
    }

    removeRouteId(routeid: string) {
        delete this.compMap[routeid];
    }

    canDeactivate(parentComp: Component, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const comp = this.compMap[route.params["routeid"]];
        if (comp && implementsTKeys<ITCITenantRouteDeactivator>(comp, ["canDeactivate"])) {
            return comp.canDeactivate(route, state);
        }

        return Observable.of(true);
    }
}
